import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import axios from "axios";
import Swal from "sweetalert2";
import mitt from "mitt";
const emitter = mitt();
import authService from "./services/auth.service";

const app = createApp(App).use(i18n);
app.config.globalProperties.emitter = emitter;

app.config.globalProperties.emitter = emitter;

function buildToast(icon, title) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  Toast.fire({ icon, title });
}

app.mixin({
  methods: {
    $success(msg) {
      buildToast("success", `${msg}`);
    },
    $error(msg, error = null) {
      if (error !== null) {
        if (axios.isCancel(error)) return;
        if (error.message === "error.response is undefined") return;
        console.log(error);
      }
      buildToast("error", `${msg}`);
    },
    $warning(msg) {
      buildToast("warning", `${msg}`);
    },
    $info(msg) {
      buildToast("info", `${msg}`);
    },
    $can(permissionName) {
      if (!this.$store.state.auth.user?.permissions) return false;
      return this.$store.state.auth.user.permissions.includes(permissionName);
    },
    $confirm(
      title,
      text,
      confirmButtonText,
      cancelButtonText,
      icon = "warning"
    ) {
      return Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText,
        cancelButtonText,
      });
    },
  },
});

// Promote to globalProperties (stand‑alone functions)
app.config.globalProperties.$success = (msg) => buildToast("success", `${msg}`);
app.config.globalProperties.$error = (msg, error = null) => {
  if (error !== null) {
    if (axios.isCancel(error)) return;
    if (error.message === "error.response is undefined") return;
    console.log(error);
  }
  buildToast("error", `${msg}`);
};
app.config.globalProperties.$warning = (msg) => buildToast("warning", `${msg}`);
app.config.globalProperties.$info = (msg) => buildToast("info", `${msg}`);
app.config.globalProperties.$can = function (permissionName) {
  const store = app.config.globalProperties.$store;
  if (!store?.state.auth.user?.permissions) return false;
  return store.state.auth.user.permissions.includes(permissionName);
};
app.config.globalProperties.$confirm = (
  title,
  text,
  confirmButtonText,
  cancelButtonText,
  icon = "warning"
) => {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText,
    cancelButtonText,
  });
};

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";

app
  .use(router)
  .use(store)
  .use(VueViewer)
  .mixin({
    methods: {},
  })
  .mount("#app");

let cancelSource = axios.CancelToken.source();

const requestInterceptor = (config) => {
  config.cancelToken = cancelSource.token;
  // console.log(config);
  // config.headers.setAuthorization(null);
  return config;
};

axios.defaults.withCredentials = true;

axios.interceptors.request.use(requestInterceptor);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!error.response) {
      return Promise.reject(error);
      // console.log("No error response");
      // return error;
    }
    if (error.response.status === 401 && router.currentRoute.name !== "login") {
      if (error.config.url == "https://api.varsanpr.com/api/auth/refresh") {
        // Prevent infinite loop if refresh token request fails
        console.log("Refresh token request failed, redirecting to login");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.href =
          "https://gateway.varsanpr.com/login?redirect=" +
          window.location.origin +
          "/login";
        return Promise.reject(error);
      }
      // 401, attempt to refresh token
      if (!authService.refreshPromise) {
        authService.refreshPromise = authService.refreshToken().then(() => {
          authService.refreshPromise = null;
        });
      }
      await authService.refreshPromise;
      return axios(error.config);
    }

    if (error.response.status === 403) {
      if (error.response.data !== undefined) {
        if (error.response.data["2fa"] === "required") {
          console.info("2FA IS REQUIRED");
          router.replace({
            name: "2fa",
            params: {
              route: router.currentRoute.name,
              params: router.currentRoute.params,
              first: true,
            },
          });
          return error;
        }
        if (error.response.data["2fa"] === "expired") {
          console.info("2FA IS REQUIRED");
          router.replace({
            name: "twoFactorAuth",
            params: {
              route: router.currentRoute.name,
              first: false,
            },
          });
          return error;
        }
      }
      console.log("Error Response is 403");
      router.replace("/");
    }

    if (axios.isCancel(error)) {
      console.log("Error is due to cancellation by user.");
    }
    return Promise.reject(error);
    // return error;
  }
);
